import axios from "axios";
import {openProductPopupHandler} from "./productPopup";
import {toggleMicrocart} from "./microcart";

const updateCartItemsCount = async () => {
    let {status, data} = await axios.get(`${window.Shopify.routes.root}cart.js`);

    if(status === 200) {
        const cartItemsCountElements = [...document.querySelectorAll('.js-cart-items-count')];

        cartItemsCountElements.map(cartItemsCount => cartItemsCount.setAttribute('data-count', data.items.length));
    }
}

export const addToCartHandler = async (e) => {
    e.preventDefault();

    const form = e.currentTarget;
    const selectedVariant = form.querySelector('.js-product-variant:checked') ? form.querySelector('.js-product-variant:checked').value : null;
    const selectedRelated = [...document.querySelectorAll('.js-product-related:checked')];
    const dynamicRelatedElement = form.getAttribute('data-dynamic-variant');
    const dynamicRelated = dynamicRelatedElement ? dynamicRelatedElement.split(",") : null;
    
    const singleOrPairSelection = form.querySelector('.js-single-pair-input:checked');
    const isPairSelected = singleOrPairSelection && singleOrPairSelection.value === 'pair';
    const quantity = isPairSelected ? 2 : 1;

    const bundleSelectedItems = form.querySelector('.js-bundle-selected-items');
    const hasBundleItems = bundleSelectedItems && bundleSelectedItems.value && bundleSelectedItems.value !== '[]';

    const formData = {
        items: []
    };

    form.setAttribute('data-state', 'loading');

    if(selectedVariant != null) {
        const item = {id: selectedVariant, quantity: quantity};

        if(hasBundleItems) {
            item.properties = {_bundle_selected_items: bundleSelectedItems.value};
        }

        formData.items.push(item);
    }

    if(selectedRelated) {
        selectedRelated.map(selected => {
            formData.items.push({id: selected.value, quantity: 1});
        });
    }

    if(dynamicRelated) {
        dynamicRelated.map(selected => {
            formData.items.push({id: selected, quantity: 1});
        });
    }

    if(form.classList.contains('js-cartupsell-add')) {
        formData.items.push({id: form.dataset.id, quantity: 1});
    }

    try {
        let {status} = await axios.post(`${form.action}.js`, formData);

        if(status === 200) {
            await updateCartItemsCount();

            form.setAttribute('data-state', 'done');

            if(form.hasAttribute('data-popup')) {
                openProductPopupHandler();
            }
            if(form.hasAttribute('data-microcart')) {
                toggleMicrocart(false);
            }
            if(form.classList.contains('js-cartupsell-add')) {
                toggleMicrocart(true);
            }

            setTimeout(() => {
                form.removeAttribute('data-state');
            }, 1500);

        }
    } catch (e) {
        const errorMessage = e.response.data;
        const errorHtml = '<div class="pb-3">' + errorMessage.description + '</div>';
        const errorPlaceholder = form.querySelector('.js-addtocart-error');

        errorPlaceholder.innerHTML = errorHtml;
    }

}
